module.exports = __webpack_public_path__ + "static/media/drift-boss.1881bab0.jpg";